import React from "react";

import NavBar from "../../components/general/NavBarApp";
import MissionCreationForm from "../../components/mission/missionCreationForm";
import "../../assets/css/mission-creation.css";
import NavBarApp from "../../components/general/NavBarApp";

const MissionCreation = () => {
  return (
    <div className="main">
      <NavBarApp userType="entreprise" />
      <MissionCreationForm />
    </div>
  );
};

export default MissionCreation;
